import getLocalString from "constants/Localization";
import { useUpdateDailyFormWorkOrderStatusMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateDailyFormWorkOrderStatus() {
  const [mutation, { loading, data, error }] = useUpdateDailyFormWorkOrderStatusMutation({
    refetchQueries: [
      "customGetDailyFormWorkOrders",
      "customGetVehicleDailyFormWorkOrders",
      "customGetDailyFormWorkOrder",
    ],
  });

  const [updateDailyFormWorkOrderStatus, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateDailyFormWorkOrderStatus",
    },
    {
      successMessage: getLocalString("fleet.update-work-order-status-success"),
      failureMessage: getLocalString("fleet.update-work-order-status-failure"),
    }
  );

  return [updateDailyFormWorkOrderStatus, context] as const;
}
